/** The rules module's URLs. Its own file so the list's rows and the rule page can both name them
 *  without importing each other. `RULE_DETAIL_PATH` in App.tsx is the route these resolve against. */
export const RULES_PATH = '/rules'
export const rulePath = (id: string) => `${RULES_PATH}/${encodeURIComponent(id)}`
